import React, { useEffect, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';

interface ScoreDisplayProps {
  score: number;
  total: number;
}

const ScoreDisplay: React.FC<ScoreDisplayProps> = ({ score, total }) => {
  const [barWidth, setBarWidth] = useState(0);
  const { t } = useTranslation('result');

  useEffect(() => {
    const timer = setTimeout(() => {
      setBarWidth((score / total) * 100);
    }, 300);
    return () => clearTimeout(timer);
  }, [score, total]);

  const level = score === 3 ? t('score.levelPerfect') : score >= 2 ? t('score.levelGood') : t('score.levelLow');

  return (
    <div className="text-center">
      <div className="text-6xl mb-4">{'\uD83C\uDFC6'}</div>
      <h2 className="text-3xl font-bold text-white mb-1">
        {score}/{total}
      </h2>
      <p className="text-blue-300 text-lg mb-6">{t('score.label')}</p>

      <div className="w-full bg-white/10 rounded-full h-4 mb-4 overflow-hidden">
        <div
          className="h-4 rounded-full bg-gradient-to-r from-blue-500 to-cyan-400 score-bar-fill"
          style={{ width: `${barWidth}%` }}
        />
      </div>

      <p className="text-white/80 text-base leading-relaxed mb-6">
        <Trans i18nKey="score.message" ns="result" values={{ level }} components={{ 1: <strong className="text-white" /> }} />
      </p>

      <p className="text-yellow-300 text-base font-semibold">
        {t('score.teaser')}
      </p>
    </div>
  );
};

export default ScoreDisplay;
